import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Bookmark, Building2, FileText, GitCompare, Landmark, Trash2, Users, X } from 'lucide-react';
import { useCompareStore } from '../../stores/compareStore';
import { useFollowStore, type FollowKind } from '../../stores/followStore';
import { DockPane } from './DockPane';

/* The side dock's own panels — on every page: «Харьцуулах» and «Дагаж буй». */

export const ComparePane: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const { selectedIds, labels, toggle, clear } = useCompareStore();
  const navigate = useNavigate();
  return (
    <DockPane icon={GitCompare} title="Харьцуулах" onClose={onClose}
      actions={selectedIds.length > 0 ? <button type="button" className="dock-pane-link" onClick={clear}>Цэвэрлэх</button> : undefined}>
      {selectedIds.length === 0 ? (
        <p className="dock-empty">
          Хайлтын тендерийн жагсаалтад мөрийн эхний чагтаар 2–4 тендер сонгоод энд харьцуулна.
        </p>
      ) : (
        <>
          <ul className="dock-list">
            {selectedIds.map((id) => (
              <li key={id}>
                <FileText size={14} />
                <Link to={`/tender/${id}`}>{labels[id] ?? `Тендер #${id}`}</Link>
                <button type="button" onClick={() => toggle(id)} title="Хасах" aria-label="Хасах"><X size={13} /></button>
              </li>
            ))}
          </ul>
          <p className="dock-note">{selectedIds.length} / 4 тендер{selectedIds.length < 2 ? ' — дор хаяж 2-ыг сонгоно' : ''}</p>
          <button type="button" className="dock-primary" disabled={selectedIds.length < 2}
            onClick={() => navigate(`/compare?ids=${selectedIds.join(',')}`)}>
            <GitCompare size={14} /> Харьцуулах
          </button>
        </>
      )}
    </DockPane>
  );
};

const FOLLOW_META: Record<FollowKind, { label: string; path: string; Icon: typeof FileText }> = {
  tender: { label: 'Тендер', path: '/tender', Icon: FileText },
  bidder: { label: 'Компани', path: '/bidder', Icon: Users },
  organization: { label: 'Байгууллага', path: '/organization', Icon: Building2 },
  governor: { label: 'Төсвийн захирагч', path: '/governor', Icon: Landmark },
};

export const FollowPane: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const { items, remove } = useFollowStore();
  const kinds = (Object.keys(FOLLOW_META) as FollowKind[]).filter((k) => items.some((i) => i.kind === k));
  return (
    <DockPane icon={Bookmark} title="Дагаж буй" onClose={onClose}>
      {items.length === 0 ? (
        <p className="dock-empty">Тендер, компани, байгууллагын хуудсан дээрх «Дагах» товчоор нэмнэ. Жагсаалт энэ хөтөч дээр хадгалагдана.</p>
      ) : kinds.map((k) => {
        const { label, path, Icon } = FOLLOW_META[k];
        return (
          <div key={k} className="dock-group">
            <div className="dock-group-title">{label}</div>
            <ul className="dock-list">
              {items.filter((i) => i.kind === k).map((i) => (
                <li key={`${i.kind}-${i.id}`}>
                  <Icon size={14} />
                  <Link to={`${path}/${i.id}`}>{i.label}</Link>
                  <button type="button" onClick={() => remove(i.kind, i.id)} title="Дагахаа болих" aria-label="Дагахаа болих"><Trash2 size={13} /></button>
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </DockPane>
  );
};
